<template>
  <el-tooltip
    :disabled="isDisabled"
    :content="tooltip"
    placement="top"
    popper-class="chip-tooltip"
  >
    <chip
      class="chip-icon"
      v-bind="$attrs"
      v-on="$listeners"
    >
    <slot>
    </slot>
    </chip>
  </el-tooltip>
</template>

<script>
  import Chip from '@/components/common/Chip'
  import { isEmpty, compose, propOr } from 'ramda'

  export default {
    components: {
      Chip,
    },
    props: {
      tooltip: {
        type: String,
        default: "",
      },
    },
    computed: {
      isDisabled: compose(isEmpty, propOr('', 'tooltip'))
    },
  }
</script>

<style lang="scss" scoped>
button.chip-icon::v-deep {
  &, &:focus, &:hover, &:active {
    border-radius: 0%;
    margin: auto 15px;
    background-color: transparent;
    border: none;
    padding: 0px;
  }

  i:before {
    height: 24px;
    width: 24px;
    padding: 0px;
  }
}
</style>
